import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "StatusDependenciesViewerDialog",
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "alert alert-warning text-dark",
  role: "alert"
}
const _hoisted_10 = {
  key: 0,
  class: "card mt-3"
}
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "list-group list-group-flush" }
const _hoisted_13 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_14 = {
  key: 1,
  class: "card mt-3"
}
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "list-group list-group-flush" }
const _hoisted_17 = {
  key: 2,
  class: "card mt-3"
}
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "list-group list-group-flush" }
const _hoisted_20 = {
  key: 3,
  class: "card mt-3"
}
const _hoisted_21 = { class: "card-header" }
const _hoisted_22 = { class: "list-group list-group-flush" }
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = {
  key: 1,
  if: "StatusDeleterDialog",
  class: "modal-mask"
}
const _hoisted_25 = { class: "modal-wrapper" }
const _hoisted_26 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  class: "alert alert-danger text-dark",
  role: "alert"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-6 text-right" }
const _hoisted_38 = {
  key: 2,
  class: "container"
}
const _hoisted_39 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_40 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_41 = { class: "table table-bordered" }
const _hoisted_42 = { style: {"width":"120px"} }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "form-group m-0 p-0" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { style: {"width":"90px"} }
const _hoisted_48 = { class: "dropdown" }
const _hoisted_49 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.depViewer.opened === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "modal-title" }, "Status dependencies", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.depViewer.close()))
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (!_ctx.depViewer.rm)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                        _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", null, [
                            _cache[10] || (_cache[10] = _createTextVNode("The status '", -1 /* CACHED */)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.depViewer.rm.Name), 1 /* TEXT */),
                            _cache[11] || (_cache[11] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.depViewer.rm.Count), 1 /* TEXT */),
                            _cache[12] || (_cache[12] = _createTextVNode(" places.", -1 /* CACHED */))
                          ])
                        ]),
                        (_ctx.depViewer.rm.Reports.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, " Reports (" + _toDisplayString(_ctx.depViewer.rm.Reports.length) + ") ", 1 /* TEXT */),
                              _createElementVNode("ul", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depViewer.rm.Reports, (r) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item",
                                    key: r.Id
                                  }, [
                                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [
                                      _createTextVNode(_toDisplayString(r.Name), 1 /* TEXT */)
                                    ])), [
                                      [_directive_sanitizedHref, _ctx.url_ReportViewPage(r)]
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.depViewer.rm.Lists.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, " Lists (" + _toDisplayString(_ctx.depViewer.rm.Lists.length) + ") ", 1 /* TEXT */),
                              _createElementVNode("ul", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depViewer.rm.Lists, (l) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item",
                                    key: l.Id
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(l.Name), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.depViewer.rm.Notifications.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, " Notifications (" + _toDisplayString(_ctx.depViewer.rm.Notifications.length) + ") ", 1 /* TEXT */),
                              _createElementVNode("ul", _hoisted_19, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depViewer.rm.Notifications, (n) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item",
                                    key: n.Id
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(n.Name), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.depViewer.rm.Alternatives.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, " Alternatives (" + _toDisplayString(_ctx.depViewer.rm.Alternatives.length) + ") ", 1 /* TEXT */),
                              _createElementVNode("ul", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depViewer.rm.Alternatives, (a) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item",
                                    key: a.Id
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(a.Name), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.depViewer.close())),
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Close")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.statusDeleter.opened === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: _normalizeClass(["modal-header", {'bg-danger': (_ctx.statusDeleter.rm && _ctx.statusDeleter.rm.HasDependants === false)}])
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "modal-title" }, "Delete status", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.statusDeleter.close()))
                  }, "×")
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_28, [
                  (!_ctx.statusDeleter.rm)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_29, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                        _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_ctx.statusDeleter.rm.HasDependants === true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this status", -1 /* CACHED */)),
                                _createElementVNode("p", null, [
                                  _cache[15] || (_cache[15] = _createTextVNode(" The status '", -1 /* CACHED */)),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.statusDeleter.rm.Name), 1 /* TEXT */),
                                  _cache[16] || (_cache[16] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.statusDeleter.rm.Count), 1 /* TEXT */),
                                  _cache[17] || (_cache[17] = _createTextVNode(" places. To delete this status, first remove it from where it is used. ", -1 /* CACHED */))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Are you sure you want to delete this status?", -1 /* CACHED */)),
                              _createElementVNode("p", null, [
                                _cache[19] || (_cache[19] = _createTextVNode("You are about to delete '", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.statusDeleter.rm.Name), 1 /* TEXT */),
                                _cache[20] || (_cache[20] = _createTextVNode("'. This can't be undone.", -1 /* CACHED */))
                              ])
                            ]))
                      ]))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.statusDeleter.rm?.HasDependants === false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-danger",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteKanbanStatusCommand && _ctx.handleDeleteKanbanStatusCommand(...args)))
                      }, "Delete"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.statusDeleter.rm?.HasDependants === true)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showStatusDependenciesViewer(_ctx.statusDeleter.rm.Id)))
                      }, "View dependencies"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.statusDeleter.close()))
                  }, "Cancel")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Kanban statuses")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary mr-1",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createStatus && _ctx.createStatus(...args)))
          }, "Add status"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateKanbanStatusesCommand && _ctx.handleUpdateKanbanStatusesCommand(...args)))
          }, "Save changes")
        ])
      ])
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          (_ctx.AlternativeStatusesView.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("strong", null, "No statuses", -1 /* CACHED */),
                _createTextVNode(" - there must be at least one status. ", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true),
          (_ctx.errors?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e) => {
                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(e.Error), 1 /* TEXT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("table", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativeStatusesView, (s) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: s.OrderValue
              }, [
                _createElementVNode("td", _hoisted_42, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.moveUp(s)),
                    class: "btn btn-outline-secondary mr-1",
                    style: {"max-width":"40px","width":"40px"}
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("i", {
                      class: "fa fa-long-arrow-up",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_43),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.moveDown(s)),
                    class: "btn btn-outline-secondary",
                    style: {"max-width":"40px","width":"40px"}
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("i", {
                      class: "fa fa-long-arrow-down",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_44)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((s.Name) = $event),
                      class: "form-control"
                    }, null, 8 /* PROPS */, _hoisted_46), [
                      [
                        _vModelText,
                        s.Name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _cache[26] || (_cache[26] = _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary dropdown-toggle",
                      "data-toggle": "dropdown"
                    }, " Actions ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_49, [
                      (s.Id)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showStatusDependenciesViewer(s.Id))
                          }, "View dependencies", 8 /* PROPS */, _hoisted_50))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.deleteStatus(s))
                      }, "Delete", 8 /* PROPS */, _hoisted_51)
                    ])
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}